import { API_BASE_URL } from '@/utils/env';
import { getFreshToken } from '@/utils/auth';

/**
 * Save an admin config document through the backend (admin token) instead of the
 * Firestore client SDK. The client-SDK path (`setDoc`) requires a live Firebase Auth
 * session in the browser and fails with `permission-denied` without one; this routes
 * the write through a `verifyAdmin` endpoint that writes Firestore server-side, so the
 * public pages that read these docs via onSnapshot still see the changes.
 *
 * @param path   whitelisted "collection/docId" (e.g. "pricing/current", "news/current")
 * @param data   the document object to write
 * @param merge  merge into the existing doc (default true)
 */
export async function saveAdminConfig(path: string, data: any, merge = true): Promise<void> {
  const token = await getFreshToken();
  const res = await fetch(`${API_BASE_URL}/auth/admin/config`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ path, data, merge }),
  });
  const json = await res.json().catch(() => null);
  if (!res.ok || !json?.success) throw new Error(json?.error || `Save failed (${res.status})`);
}
